import React from 'react';
import Tile from './Tile';
import { StyledMetricGroupRenderer, TableHeaderWrapper } from './styled';

const RenderMetadataGroup = ({ metadataGroup = [], title = false }) => (
  <StyledMetricGroupRenderer>
    {title
      ? (
        <TableHeaderWrapper>
          {title}
        </TableHeaderWrapper>
      ) : null}
    <React.Fragment key="cards">
      {
        metadataGroup.map(metric => (
          <Tile
            key={`${metric.name}+${metric.value}`}
            name={metric.name}
            value={metric.value}
          />
        ))
      }
    </React.Fragment>
  </StyledMetricGroupRenderer>
);

export default RenderMetadataGroup;
